/** The shared size enum (piece 1, decision 0242): every control that takes a size reads it. */
export enum Size {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export const sizes = [Size.Small, Size.Medium, Size.Large] as const;

/**
 * 🔒 A field's widths (decision 0583, amended by 0647): the three `Size`
 * members, and Column, which takes the whole column the field stands in. A
 * line table's columns are sized by the table's own width budget, so a field in
 * one of its cells fills that column rather than stopping at a size chosen for a
 * form. 🔨 Only a field takes Column; a Button, a Pill or a Checkbox reads `Size`
 * alone, and a Date Picker keeps the three, because a date is ten characters
 * wherever it stands.
 */
export const FieldSize = { Small: Size.Small, Medium: Size.Medium, Large: Size.Large, Column: 'Column' } as const;
export type FieldSize = Size | typeof FieldSize.Column;
